import { render } from "./edit.vue?vue&type=template&id=1c0598b1"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"

import "./edit.vue?vue&type=style&index=0&id=1c0598b1&style=scss&lang=css"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/apartment/dynamic/edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1c0598b1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1c0598b1', __exports__)) {
    console.log('reload')
    api.reload('1c0598b1', __exports__)
  }
  
  module.hot.accept("./edit.vue?vue&type=template&id=1c0598b1", () => {
    console.log('re-render')
    api.rerender('1c0598b1', render)
  })

}


export default __exports__